import { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import FloatingLabelInput from "../components/form_elements/FloatingLabelInput";

const Kerdesek = () => {
	const { order, updateOrder } = useOrder();
	const { saveOrder, loading: orderSaveLoading } = useOrderSave();
	const [loading, setLoading] = useState(false);
	const navigate = useStepNavigate();

	const handleAnswer = (key, value) => {
		updateOrder({
			...order,
			hmeliorder: {
				...order.hmeliorder,
				[key]: value,
				...(key === "hmeliorder_is_allergie" && value === 0 ? { hmeliorder_allergie_details: "" } : {}),
			},
		});
	};

	const handleSubmit = async () => {
		try {
			setLoading(true);
			const result = await saveOrder(order);
			if (result.success) {
				navigate("/CipoForma");
			} else {
				setLoading(false);
			}
		} catch (error) {
			console.error("Hiba a rendelés mentésekor:", error);
		}
	};

	const handleBackClick = () => {
		if (order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
			navigate("/BetetTartozek");
			return;
		}
		if (order.hmeliorder?.hmeliorder_order_type === 1) {
			const vancomponents = order.venyek.some((v) => v.components && Object.values(v.components).some((val) => !!val));
			if (vancomponents) {
				navigate("/TeritesiDij");
			} else {
				navigate("/VenyesTartozek");
			}
		} else {
			navigate("/ProjektValaszto");
		}
	};

	return (
		<TablerLayout title="Egészségügyi kérdések">
			<div className="row justify-content-center">
				<div className="col-md-10 mb-4">
					<form>
						<div className="mb-4">
							<div className="row align-items-center">
								<div className="col-md-7 col-12 mb-2 mb-md-0">
									<label className="form-label fw-bold fs-5 mb-0">Viselt-e már ortopéd cipőt?</label>
								</div>
								<div className="col-md-5 col-12">
									<div className="d-flex flex-row gap-4">
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_wearortop === 0 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_wearortop", 0)} disabled={orderSaveLoading}>
											Nem
										</button>
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_wearortop === 1 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_wearortop", 1)} disabled={orderSaveLoading}>
											Igen
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-4">
							<div className="row align-items-center">
								<div className="col-md-7 col-12 mb-2 mb-md-0">
									<label className="form-label fw-bold fs-5 mb-0">Előzőleg rendelt már máshol ortopéd cipőt?</label>
								</div>
								<div className="col-md-5 col-12">
									<div className="d-flex flex-row gap-4">
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_orderotherplace === 0 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_orderotherplace", 0)} disabled={orderSaveLoading}>
											Nem
										</button>
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_orderotherplace === 1 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_orderotherplace", 1)} disabled={orderSaveLoading}>
											Igen
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-4">
							<div className="row align-items-center">
								<div className="col-md-7 col-12 mb-2 mb-md-0">
									<label className="form-label fw-bold fs-5 mb-0">Van-e allergiája bőrre, ragasztó anyagra?</label>
								</div>
								<div className="col-md-5 col-12">
									<div className="d-flex flex-row gap-4">
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_allergie === 0 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_allergie", 0)} disabled={orderSaveLoading}>
											Nem
										</button>
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_allergie === 1 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_allergie", 1)} disabled={orderSaveLoading}>
											Igen
										</button>
									</div>
								</div>
							</div>
						</div>
						{order.hmeliorder.hmeliorder_is_allergie === 1 && (
							<div className="mb-4">
								<div className="row align-items-center">
									<div className="col-md-7 col-12 mb-2 mb-md-0">
										<label className="form-label fw-bold fs-5 mb-0">Kérem részletezze az allergiát:</label>
									</div>
									<div className="col-md-5 col-12">
										<FloatingLabelInput
											id="allergie_details"
											label="Allergia részletezés"
											type="text"
											className="form-control form-control-lg"
											placeholder="Kérem részletezze az allergiát"
											value={order.hmeliorder.hmeliorder_allergie_details}
											onChange={(e) => handleAnswer("hmeliorder_allergie_details", e.target.value)}
											minLength={10}
											style={{ fontSize: 20, padding: "0.75rem 1rem" }}
											disabled={orderSaveLoading}
										/>
									</div>
								</div>
							</div>
						)}

						<div className="mb-4">
							<div className="row align-items-center">
								<div className="col-md-7 col-12 mb-2 mb-md-0">
									<label className="form-label fw-bold fs-5 mb-0">Szedett-e vízhajtót méretvétel előtt?</label>
								</div>
								<div className="col-md-5 col-12">
									<div className="d-flex flex-row gap-4">
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_takepill === 0 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_takepill", 0)} disabled={orderSaveLoading}>
											Nem
										</button>
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_takepill === 1 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_takepill", 1)} disabled={orderSaveLoading}>
											Igen
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-4">
							<div className="row align-items-center">
								<div className="col-md-7 col-12 mb-2 mb-md-0">
									<label className="form-label fw-bold fs-5 mb-0">Volt-e előláb vagy boka műtétje?</label>
								</div>
								<div className="col-md-5 col-12">
									<div className="d-flex flex-row gap-4">
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_doneoper === 0 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_doneoper", 0)} disabled={orderSaveLoading}>
											Nem
										</button>
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_doneoper === 1 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_doneoper", 1)} disabled={orderSaveLoading}>
											Igen
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-4">
							<div className="row align-items-center">
								<div className="col-md-7 col-12 mb-2 mb-md-0">
									<label className="form-label fw-bold fs-5 mb-0">Van-e csontkinövése?</label>
								</div>
								<div className="col-md-5 col-12">
									<div className="d-flex flex-row gap-4">
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_osselet === 0 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_osselet", 0)} disabled={orderSaveLoading}>
											Nem
										</button>
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_osselet === 1 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_osselet", 1)} disabled={orderSaveLoading}>
											Igen
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-4">
							<div className="row align-items-center">
								<div className="col-md-7 col-12 mb-2 mb-md-0">
									<label className="form-label fw-bold fs-5 mb-0">Van-e nyomásra érzékeny rész a lábán?</label>
								</div>
								<div className="col-md-5 col-12">
									<div className="d-flex flex-row gap-4">
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_sensitpart === 0 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_sensitpart", 0)} disabled={orderSaveLoading}>
											Nem
										</button>
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.hmeliorder_is_sensitpart === 1 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("hmeliorder_is_sensitpart", 1)} disabled={orderSaveLoading}>
											Igen
										</button>
									</div>
								</div>
							</div>
						</div>
						<div className="mb-4">
							<div className="row align-items-center">
								<div className="col-md-7 col-12 mb-2 mb-md-0">
									<label className="form-label fw-bold fs-5 mb-0">Várhatóan 3 cm-nél nagyobb lesz az emelés?</label>
								</div>
								<div className="col-md-5 col-12">
									<div className="d-flex flex-row gap-4">
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.plus_hmeliorder_is_emeles === 0 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("plus_hmeliorder_is_emeles", 0)} disabled={orderSaveLoading}>
											Nem
										</button>
										<button type="button" className={`btn btn-lg w-50 py-3 ${order.hmeliorder.plus_hmeliorder_is_emeles === 1 ? "btn-primary shadow" : "btn-outline-primary"}`} style={{ fontSize: 20, borderWidth: 2 }} onClick={() => handleAnswer("plus_hmeliorder_is_emeles", 1)} disabled={orderSaveLoading}>
											Igen
										</button>
									</div>
								</div>
							</div>
						</div>
					</form>
					<div className="d-flex justify-content-between mt-4">
						<StepperNavButton side="left" label="Vissza" onClick={handleBackClick} disabled={orderSaveLoading} />
						<StepperNavButton side="right" label="Tovább" onClick={handleSubmit} disabled={(order.hmeliorder.hmeliorder_is_allergie === 1 && order.hmeliorder.hmeliorder_allergie_details.trim().length < 3) || orderSaveLoading} />
					</div>
				</div>
			</div>
		</TablerLayout>
	);
};

export default Kerdesek;
